// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: structs/structs/reactor_diversity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "structs.structs";

export interface ReactorDiversityPosition {
  ownerId: string;
  reactorId: string;
  power: string;
}

export interface OwnerReactorDiversity {
  ownerId: string;
  power: string;
  squaredPower: string;
  appliedBonus: string;
}

function createBaseReactorDiversityPosition(): ReactorDiversityPosition {
  return { ownerId: "", reactorId: "", power: "" };
}

export const ReactorDiversityPosition: MessageFns<ReactorDiversityPosition> = {
  encode(message: ReactorDiversityPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ownerId !== "") {
      writer.uint32(10).string(message.ownerId);
    }
    if (message.reactorId !== "") {
      writer.uint32(18).string(message.reactorId);
    }
    if (message.power !== "") {
      writer.uint32(26).string(message.power);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReactorDiversityPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReactorDiversityPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ownerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reactorId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.power = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReactorDiversityPosition {
    return {
      ownerId: isSet(object.ownerId) ? globalThis.String(object.ownerId) : "",
      reactorId: isSet(object.reactorId) ? globalThis.String(object.reactorId) : "",
      power: isSet(object.power) ? globalThis.String(object.power) : "",
    };
  },

  toJSON(message: ReactorDiversityPosition): unknown {
    const obj: any = {};
    if (message.ownerId !== "") {
      obj.ownerId = message.ownerId;
    }
    if (message.reactorId !== "") {
      obj.reactorId = message.reactorId;
    }
    if (message.power !== "") {
      obj.power = message.power;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReactorDiversityPosition>, I>>(base?: I): ReactorDiversityPosition {
    return ReactorDiversityPosition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReactorDiversityPosition>, I>>(object: I): ReactorDiversityPosition {
    const message = createBaseReactorDiversityPosition();
    message.ownerId = object.ownerId ?? "";
    message.reactorId = object.reactorId ?? "";
    message.power = object.power ?? "";
    return message;
  },
};

function createBaseOwnerReactorDiversity(): OwnerReactorDiversity {
  return { ownerId: "", power: "", squaredPower: "", appliedBonus: "0" };
}

export const OwnerReactorDiversity: MessageFns<OwnerReactorDiversity> = {
  encode(message: OwnerReactorDiversity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ownerId !== "") {
      writer.uint32(10).string(message.ownerId);
    }
    if (message.power !== "") {
      writer.uint32(18).string(message.power);
    }
    if (message.squaredPower !== "") {
      writer.uint32(26).string(message.squaredPower);
    }
    if (message.appliedBonus !== "0") {
      writer.uint32(32).uint64(message.appliedBonus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OwnerReactorDiversity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOwnerReactorDiversity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ownerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.power = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.squaredPower = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.appliedBonus = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OwnerReactorDiversity {
    return {
      ownerId: isSet(object.ownerId) ? globalThis.String(object.ownerId) : "",
      power: isSet(object.power) ? globalThis.String(object.power) : "",
      squaredPower: isSet(object.squaredPower) ? globalThis.String(object.squaredPower) : "",
      appliedBonus: isSet(object.appliedBonus) ? globalThis.String(object.appliedBonus) : "0",
    };
  },

  toJSON(message: OwnerReactorDiversity): unknown {
    const obj: any = {};
    if (message.ownerId !== "") {
      obj.ownerId = message.ownerId;
    }
    if (message.power !== "") {
      obj.power = message.power;
    }
    if (message.squaredPower !== "") {
      obj.squaredPower = message.squaredPower;
    }
    if (message.appliedBonus !== "0") {
      obj.appliedBonus = message.appliedBonus;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OwnerReactorDiversity>, I>>(base?: I): OwnerReactorDiversity {
    return OwnerReactorDiversity.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OwnerReactorDiversity>, I>>(object: I): OwnerReactorDiversity {
    const message = createBaseOwnerReactorDiversity();
    message.ownerId = object.ownerId ?? "";
    message.power = object.power ?? "";
    message.squaredPower = object.squaredPower ?? "";
    message.appliedBonus = object.appliedBonus ?? "0";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
